export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20gradient%20background%20with%20soft%20cream%20peach%20and%20sand%20tones%20delicate%20organic%20shapes%20floating%20subtly%20plenty%20of%20negative%20space%20dreamy%20ethereal%20atmosphere%20editorial%20style%20gentle%20diffused%20lighting%20elegant%20modern%20design%20high%20end%20fashion%20directory%20vibe&width=1600&height=900&seq=kakobuy-hero-v2&orientation=landscape"
          alt="Kakobuy Spreadsheet product directory background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 pt-24 pb-20 md:pt-28 md:pb-24">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 text-foreground-800 text-xs md:text-sm font-label mb-6">
            <i className="ri-verified-badge-fill text-accent-500 text-sm"></i>
            Verified Directory — Updated June 2026
          </div>

          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 tracking-tight drop-shadow-sm">
            Kakobuy Spreadsheet: The Largest Free Product Directory in 2026
          </h1>

          <p className="text-white/85 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover verified products, trusted Yupoo sellers, price comparisons, shipping guides, and the latest Kakobuy Spreadsheet updates — all in one place, updated daily.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-50 text-foreground-950 font-label font-semibold text-sm hover:bg-background-100 transition-all cursor-pointer whitespace-nowrap text-center"
            >
              Browse Spreadsheet
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-label font-semibold text-sm hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-center"
            >
              Start Shopping
              <i className="ri-shopping-bag-line ml-2"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-10 text-white/70 text-xs md:text-sm">
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line"></i> Updated Daily
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line"></i> Verified Sellers
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line"></i> Price Comparison
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line"></i> Shipping Guides
            </span>
            <span className="flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-check-line"></i> Free Access
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}